import { Toasts } from '@fourthwall/components'
import type { CollectionsApi } from '@fourthwall/services/dist/CollectionsApiClient'
import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation } from '@tanstack/react-query'

type MutationPayload = {
  collectionId: string
  payload: CollectionsApi.UpdateCollectionState.RequestBody
}

type MutationViolation = {
  field: string
  title: string
}

type MutationError = {
  violations?: MutationViolation[] | null
  title?: string
}

export const mapErrorToMessage = (error?: MutationError): string => {
  if (!error) return 'Something went wrong'

  if (
    error.violations?.some(
      (violation) =>
        violation.field == 'newTimeFrame.to' && violation.title == 'must be a future date',
    )
  ) {
    return 'End date must be in the future'
  }

  return error.title || 'Something went wrong'
}

export const useStatusMutation = () => {
  const mutationKey = 'useStatusMutation'
  const mutation = useMutation({
    mutationKey: [mutationKey],
    mutationFn: async ({ collectionId, payload }: MutationPayload) => {
      const { data } = await CollectionsApiClient.updateCollectionState({ collectionId }, payload)

      return data
    },
    onError: (error: ApiError) => {
      Toasts.notify(mapErrorToMessage(error.response?.data), {
        toastId: mutationKey,
        type: 'error',
      })
    },
  })

  return {
    statusMutation: mutation,
  }
}
